import React, { ReactNode } from 'react';
import { DatePicker, Input } from 'antd';
import type { Rule } from 'antd/es/form';
import { useTranslation } from 'react-i18next';

export type SignUpFormItem = {
  type: 'text' | 'email' | 'password' | 'custom';
  label: string;
  name: string;
  rules?: Rule[];
  render?: () => ReactNode;
};

export const getSignUpFormItems = (
  t: (key: string) => string,
): SignUpFormItem[] => [
  {
    type: 'text',
    label: t('SIGN_UP.FIRST_NAME'),
    name: 'firstName',
    rules: [{ required: true }],
  },
  {
    type: 'text',
    label: t('SIGN_UP.LAST_NAME'),
    name: 'lastName',
    rules: [{ required: true }],
  },
  {
    type: 'text',
    label: t('SIGN_UP.USERNAME'),
    name: 'username',
    rules: [{ required: true }],
  },
  {
    type: 'email',
    label: t('SIGN_UP.EMAIL_ADDRESS'),
    name: 'email',
    rules: [{ required: true }],
  },
  {
    type: 'password',
    label: t('SIGN_UP.PASSWORD'),
    name: 'password',
    rules: [{ required: true }],
    render: () => <Input.Password visibilityToggle />,
  },
  {
    type: 'password',
    label: t('SIGN_UP.CONFIRM_PASSWORD'),
    name: 'confirmPassword',
    rules: [
      {
        required: true,
        message: t('SIGN_UP.PLEASE_CONFIRM_PASSWORD'),
      },
      ({ getFieldValue }) => ({
        validator(_, value) {
          const allValues = getFieldValue([]);
          const formIndex = Object.keys(allValues || {}).find(
            (key) => allValues[key]?.confirmPassword === value,
          );

          if (
            !value ||
            getFieldValue([Number(formIndex), 'password']) === value
          ) {
            return Promise.resolve();
          }

          return Promise.reject(new Error(t('SIGN_UP.PASSWORDS_DO_NOT_MATCH')));
        },
      }),
    ],
    render: () => <Input.Password visibilityToggle />,
  },
  {
    type: 'custom',
    label: t('SIGN_UP.DEACTIVATION_DATE'),
    name: 'deactivation_date',
    render: () => <DatePicker />,
  },
];
